<template>
  <div class="ui six link cards">
    <div
      class="card"
      v-for="module in display_modules"
      v-bind:key="module.module_id"
      v-on:click="$emit('go_to_module', module)"
      style="margin: 10px 10px !important"
    >
      <div class="content">
        <h3 class="ui icon header" style="margin-bottom:0">
          <img :src="module.sys_module.setup.image" class="ui image" />
          <div class="content" style="margin-top:8px">
            {{ $t(module.sys_module.setup.name) }}
          </div>
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeDesktopView",
  props: {
    display_modules: {
      type: Array,
    },
  },
};
</script>
